import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-why-ketto',
  standalone: true,
  imports: [CommonModule, NgxGlideModule, MatIconModule],
  templateUrl: './why-ketto.component.html',
  styleUrls: ['./why-ketto.component.scss']
})
export class WhyKettoComponent {
  @Input() showCustomArrows: boolean = false;
  @Input() showArrows: boolean = true;
  cards = [
    { icon: '/assets/images/home-v2/supported-by.png', title: `<div>Supported By</div> <div>55,00,000+ Contributors</div>` },
    { icon: '/assets/images/home-v2/number-1.png', title: `<div>Industry’s best</div> <div>fundraising</div> <div>success rate</div>` },
    { icon: '/assets/images/home-v2/manage_accounts.png', title: `Easy-To-Manage Tools To Boost Results` },
    { icon: '/assets/images/home-v2/payments-circle.png', title: `Contributions via all popular payment modes` },
    { icon: '/assets/images/home-v2/support.png', title: `<div>Get Expert</div> <div>Support 24/7</div>` },
    { icon: '/assets/images/home-v2/smart-dashboard.png', title: `<div>A Dedicated Smart-</div><div>Dashboard</div>` },
    { icon: '/assets/images/home-v2/withdraw.png', title: `<div>Withdraw Funds</div> <div>Without Hassle</div>` },
    { icon: '/assets/images/home-v2/intl.png', title: `<div>International</div> <div>Payment Support</div>` }
  ];

  breakpoints = {
    600: {
      perView: 1.4,
      showArrows: false
    }
  };

}
